import { apiWrapper } from "@/services/api";
import store from "@/store";

export const putDeclineEbusTentativeReservation = async (id) => {
  try {
    const response = await apiWrapper(
      "PUT",
      `/reservations/${id}/decline`,
      null,
      false,
      false,
      "E-BUS"
    );
    console.log(
      "putDeclineEbusTentativeReservation response.data :>> ",
      response.data
    );
  } catch (err) {
    console.log('ERROR"" putDeclineEbusTentativeReservation():', err);
    throw err;
  }
};
